import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { ROUTES } from '@/common';

import { PageMode } from './ClaimsFilterSection';
import { ACTIVE_PAGE_MODE_SEARCH_PARAM, SearchKeysForPageMode } from './ClaimsList';
import { ESCALATED_SUB_MODE_SEARCH_PARAM } from './EscalatedClaimsList';

export const useClearClaimsSearchParams = () => {
  const location = useLocation();
  const history = useHistory();

  const query = useMemo(() => new URLSearchParams(location?.search || ''), [location]);
  const pathname = useMemo(() => location.pathname, [location]);

  useEffect(() => {
      const areClaimsSearchParamsUsed = pathname?.startsWith(ROUTES.CLAIM_PROCESS) || pathname === ROUTES.CLAIMS;
      const shouldClearClaimsSearchParams = !areClaimsSearchParamsUsed && query.get(ACTIVE_PAGE_MODE_SEARCH_PARAM);

      if (shouldClearClaimsSearchParams) {
        const searchParams = Object.fromEntries(query);

        delete searchParams?.[ACTIVE_PAGE_MODE_SEARCH_PARAM];
        delete searchParams?.[ESCALATED_SUB_MODE_SEARCH_PARAM];

        Object.values(PageMode)
          .forEach((mode) => Object.values(SearchKeysForPageMode)
            .forEach((searchKey) => delete searchParams?.[`${searchKey}${mode}`]));

        const search = new URLSearchParams(searchParams).toString();

        history.push(`${pathname}${search ? `?${search}` : ''}`);
      }
    }, [pathname, query, history]);
};
